module.exports = __webpack_public_path__ + "static/img/shopping.870b0d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shopping.png
// module id = 0hH1
// module chunks = 1